import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword,
} from 'firebase/auth';
import { auth } from '../../../../firebase';

export const changePassword = async (
  currentPassword: string,
  newPassword: string,
) => {
  if (!auth) throw new Error('auth/not-configured');

  const user = auth.currentUser;
  if (!user?.email) throw new Error('auth/user-not-found');

  const credential = EmailAuthProvider.credential(user.email, currentPassword);
  await reauthenticateWithCredential(user, credential);
  await updatePassword(user, newPassword);
};
